export enum MutationTypes {
    SET_ITEM = "SET_ITEM",
    SET_PARENT = "SET_PARENT",
    DELETE_ITEM = "DELETE_ITEM",
}
